/* OtakuEN theme — front-end behaviors */
(function () {
  'use strict';

  /* ---- shared helpers ---- */
  var themeConfig = window.OtakuenTheme || {};
  function route(path) {
    var root = themeConfig.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }
  function money(cents) {
    var value = Number(cents) || 0;
    var format = themeConfig.moneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var decimals = placeholder.indexOf('no_decimals') === -1 ? 2 : 0;
    var decimalMark = placeholder.indexOf('comma_separator') !== -1 ? ',' : '.';
    var thousandsMark = placeholder.indexOf('comma_separator') !== -1 ? '.' : (placeholder.indexOf('apostrophe') !== -1 ? "'" : ',');
    var parts = (value / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    var amount = parts[0] + (decimals ? decimalMark + parts[1] : '');
    return match ? format.replace(match[0], amount) : amount + ' ' + (themeConfig.currency || '');
  }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function safeUrl(value, fallback) {
    try {
      var parsed = new URL(String(value || ''), window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
    } catch (e) {}
    return fallback || '#';
  }
  function htmlToText(value) {
    var doc = new DOMParser().parseFromString(String(value || ''), 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function readStoredArray(key) {
    try {
      var value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) { return []; }
  }
  function jsonOrError(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || 'Request failed');
      return data;
    });
  }
  function refreshCart() {
    return fetch(route('cart.js')).then(jsonOrError).then(function (cart) {
      document.querySelectorAll('.bag b, [data-drawer-count]').forEach(function (el) {
        el.textContent = el.hasAttribute('data-drawer-count') ? '(' + cart.item_count + ')' : cart.item_count;
      });
      document.querySelectorAll('.tabbar__badge').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      return cart;
    });
  }
  function addItems(items) {
    return fetch(route('cart/add.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(jsonOrError).then(refreshCart).then(function (cart) {
      if (typeof window.refreshCartDrawer === 'function') return window.refreshCartDrawer(cart);
      return cart;
    });
  }
  function openDrawerEl() { var d = document.querySelector('[data-drawer]'), o = document.querySelector('[data-drawer-overlay]'); if (d) { d.classList.add('open'); if (o) o.classList.add('open'); document.body.classList.add('drawer-open'); } }
  function ovOpen(sel) { var o = document.querySelector(sel); if (o) o.classList.add('open'); }
  function ovClose(o) { if (o) o.classList.remove('open'); }

  /* ---- Popup coordinator: only ONE modal-style popup per page load; toasts yield to it ----
     Modal popups (promo, spin-wheel) call claimModal() before showing — the first to claim wins,
     the rest stand down. setModalOpen() lets non-modal toasts (order popup) pause while a modal is up. */
  window.Otakuen = window.Otakuen || {};
  Otakuen.money = money;
  Otakuen.route = route;
  Otakuen.escapeHtml = escapeHtml;
  Otakuen.safeUrl = safeUrl;
  Otakuen.readStoredArray = readStoredArray;
  Otakuen.popups = (function () {
    var claimed = false;   // a modal has claimed the single slot this page load
    var modalOpen = false; // a modal is currently visible on screen
    return {
      claimModal: function () { if (claimed) return false; claimed = true; return true; },
      setModalOpen: function (v) { modalOpen = !!v; },
      isModalOpen: function () { return modalOpen; }
    };
  })();

  /* ---- Predictive search ---- */
  (function () {
    var input = document.querySelector('[data-search-input]');
    var res = document.querySelector('[data-search-res]');
    if (!input || !res) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); ovOpen('[data-search-ov]'); setTimeout(function () { input.focus(); }, 50); }
      if (e.target.closest('[data-search-close]')) ovClose(document.querySelector('[data-search-ov]'));
    });
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { res.innerHTML = '<div class="hint">Start typing to search the store…</div>'; return; }
      t = setTimeout(function () {
        fetch(route('search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(jsonOrError)
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { res.innerHTML = '<div class="empty">No results for “' + escapeHtml(q) + '”.</div>'; return; }
            res.innerHTML = items.map(function (p) {
              var productUrl = safeUrl(p.url, route('collections/all'));
              var imageUrl = p.featured_image && p.featured_image.url ? safeUrl(p.featured_image.url, '') : '';
              var img = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="">' : '';
              var price = p.price ? '<span>' + money(p.price) + '</span>' : '';
              return '<a href="' + escapeHtml(productUrl) + '">' + img + '<div class="t"><b>' + escapeHtml(p.title) + '</b>' + price + '</div></a>';
            }).join('');
          })
          .catch(function () { res.innerHTML = '<div class="empty">Search unavailable.</div>'; });
      }, 220);
    });
  })();

  /* ---- Quick view ---- */
  (function () {
    var ov = document.querySelector('[data-qv-ov]');
    var panel = document.querySelector('[data-qv-panel]');
    if (!ov || !panel) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qv]');
      if (btn) {
        e.preventDefault();
        ov.classList.add('open');
        panel.innerHTML = '<button class="qv__close" data-qv-close aria-label="Close">×</button><div class="qv__loading">Loading…</div>';
        fetch(btn.getAttribute('data-url') + '.js').then(jsonOrError).then(function (p) {
          var v = p.variants.find(function (variant) { return variant.available; });
          var productUrl = safeUrl(p.url || btn.getAttribute('data-url'), '#');
          var sale = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
          var imageUrl = p.featured_image ? safeUrl(p.featured_image.indexOf('http') === 0 ? p.featured_image : 'https:' + p.featured_image, '') : '';
          var img = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="">' : '';
          var addButton = v
            ? '<button class="btn" data-qv-add data-id="' + v.id + '">Add to Cart</button> '
            : '<button class="btn" disabled>Sold out</button> ';
          panel.innerHTML = '<button class="qv__close" data-qv-close aria-label="Close">×</button>' +
            '<div class="qv__grid"><div class="qv__media">' + img + '</div><div>' +
            '<h3>' + escapeHtml(p.title) + '</h3><div class="qv__price">' + money(p.price) + ' ' + sale + '</div>' +
            '<div class="rte">' + escapeHtml(htmlToText(p.description).slice(0, 220)) + '…</div>' +
            addButton + '<a class="btn btn--ghost" href="' + escapeHtml(productUrl) + '">View details</a></div></div>';
        }).catch(function () { panel.innerHTML = '<button class="qv__close" data-qv-close aria-label="Close">×</button><div class="qv__loading">Could not load product.</div>'; });
      }
      if (e.target.closest('[data-qv-close]') || e.target === ov) ovClose(ov);
      var add = e.target.closest('[data-qv-add]');
      if (add) {
        var original = add.textContent;
        add.textContent = 'Adding...';
        add.disabled = true;
        addItems([{ id: add.getAttribute('data-id'), quantity: 1 }]).then(function () {
          ovClose(ov); openDrawerEl();
        }).catch(function () {
          add.textContent = 'Could not add';
          setTimeout(function () { add.textContent = original; add.disabled = false; }, 1800);
        });
      }
    });
  })();

  /* ---- Frequently bought together ---- */
  (function () {
    var fbt = document.querySelector('[data-fbt]');
    if (!fbt) return;
    function recalc() {
      var sum = 0;
      fbt.querySelectorAll('[data-fbt-item]').forEach(function (it) {
        var chk = it.parentElement.querySelector('[data-fbt-check]');
        if (!chk || chk.checked) sum += Number(it.getAttribute('data-price'));
      });
      var tot = fbt.querySelector('[data-fbt-total]'); if (tot) tot.textContent = money(sum);
    }
    fbt.querySelectorAll('[data-fbt-check]').forEach(function (c) { c.addEventListener('change', recalc); });
    fbt.addEventListener('fbt:variant-change', recalc);
    recalc();
    var addBtn = fbt.querySelector('[data-fbt-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      var items = [];
      fbt.querySelectorAll('[data-fbt-item]').forEach(function (it) {
        var chk = it.parentElement.querySelector('[data-fbt-check]');
        if (!chk || chk.checked) items.push({ id: it.getAttribute('data-id'), quantity: 1 });
      });
      if (items.length) {
        var original = addBtn.textContent;
        addBtn.textContent = 'Adding...';
        addBtn.disabled = true;
        addItems(items).then(function () {
          addBtn.textContent = 'Added!';
          openDrawerEl();
          setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1500);
        }).catch(function () {
          addBtn.textContent = 'Could not add';
          setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2000);
        });
      }
    });
  })();

  /* ---- Promo popup (timed + exit-intent) ---- */
  (function () {
    if (window.Shopify && window.Shopify.designMode) return;
    var ov = document.querySelector('[data-promo-ov]');
    if (!ov) return;
    var KEY = 'otakuen_promo_seen';
    var opened = false;
    function open() {
      if (opened) return;
      if (!Otakuen.popups.claimModal()) return; // another modal already owns this page load
      opened = true;
      ov.classList.add('open');
      Otakuen.popups.setModalOpen(true);
    }
    function close() { ovClose(ov); Otakuen.popups.setModalOpen(false); try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-close]') || e.target === ov) close();
    });
    var seen; try { seen = localStorage.getItem(KEY); } catch (e) { seen = null; }
    if (seen) return;

    /* Timed open */
    setTimeout(open, (parseInt(ov.getAttribute('data-delay'), 10) || 4) * 1000);

    /* Exit-intent open (desktop only — cursor leaves top of viewport) */
    if (ov.getAttribute('data-exit-intent') === 'true' && window.matchMedia('(min-width:768px)').matches) {
      var onLeave = function (e) {
        if (e.clientY <= 0) { open(); document.removeEventListener('mouseout', onLeave); }
      };
      /* Small grace period so it doesn't fire instantly */
      setTimeout(function () { document.addEventListener('mouseout', onLeave); }, 3000);
    }
  })();

  /* ---- Sticky promo bar ---- */
  (function () {
    var bar = document.querySelector('[data-sticky-bar]');
    if (!bar) return;
    var KEY = 'otakuen_stickybar_closed';
    var closed; try { closed = sessionStorage.getItem(KEY); } catch (e) { closed = null; }
    if (closed) { bar.remove(); return; }
    setTimeout(function () { bar.classList.add('show'); }, 800);
    bar.querySelector('[data-sticky-close]').addEventListener('click', function () {
      bar.classList.remove('show'); try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
  })();

  /* ---- Desktop mega menu (JS hover with close-delay so links stay clickable) ---- */
  (function () {
    document.querySelectorAll('[data-mega-item]').forEach(function (item) {
      var mega = item.querySelector('.mega');
      if (!mega) return;
      var closeTimer = null;
      function show() {
        clearTimeout(closeTimer);
        mega.classList.add('open');
      }
      function hide() {
        closeTimer = setTimeout(function () { mega.classList.remove('open'); }, 350);
      }
      item.addEventListener('mouseenter', show);
      item.addEventListener('mouseleave', hide);
      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      mega.addEventListener('mouseleave', hide);
      /* keyboard: open on Enter/Space on trigger, close on Escape */
      var trigger = item.querySelector('[data-mega-trigger]');
      if (trigger) {
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); mega.classList.toggle('open'); }
          if (e.key === 'Escape') { mega.classList.remove('open'); trigger.focus(); }
        });
      }
      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) mega.classList.remove('open');
      });
    });
  })();

  /* ---- Mobile nav drawer ---- */
  (function () {
    var mobNav = document.getElementById('mobNav');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!mobNav || !toggle) return;

    function openNav() {
      mobNav.classList.add('open');
      mobNav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      mobNav.classList.remove('open');
      mobNav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      mobNav.classList.contains('open') ? closeNav() : openNav();
    });

    mobNav.addEventListener('click', function (e) {
      if (e.target.closest('[data-mob-nav-close]')) closeNav();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobNav.classList.contains('open')) closeNav();
    });
  })();

  /* ---- Countdown timers ---- */
  function pad(n) { return String(n).padStart(2, '0'); }

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var deadlineStr = el.getAttribute('data-deadline');
    if (!deadlineStr) return;
    var deadline = new Date(deadlineStr.replace(' ', 'T')).getTime();
    if (isNaN(deadline)) return;

    var d = el.querySelector('[data-days]'),
        h = el.querySelector('[data-hours]'),
        m = el.querySelector('[data-mins]'),
        s = el.querySelector('[data-secs]');

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        d.textContent = h.textContent = m.textContent = s.textContent = '00';
        clearInterval(timer);
        return;
      }
      d.textContent = pad(Math.floor(diff / 86400000));
      h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      s.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---- Hero holographic card tilt ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if (!reduce) {
    document.querySelectorAll('[data-stage]').forEach(function (stage) {
      var card = stage.querySelector('[data-hcard]');
      if (!card) return;
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'rotateY(' + (px * 16) + 'deg) rotateX(' + (-py * 16) + 'deg)';
      });
      stage.addEventListener('mouseleave', function () {
        card.style.transform = 'rotateY(0) rotateX(0)';
      });
    });
  }

  /* ---- Slideshow ---- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var slides = track ? track.children : [];
    if (slides.length < 1) return;
    var dotsWrap = root.querySelector('[data-dots]');
    var i = 0, timer = null;
    var auto = root.getAttribute('data-autoplay') === 'true';
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 5) * 1000;

    var dots = [];
    if (dotsWrap && slides.length > 1) {
      for (var s = 0; s < slides.length; s++) {
        var b = document.createElement('button');
        b.setAttribute('aria-label', 'Slide ' + (s + 1));
        (function (idx) { b.addEventListener('click', function () { go(idx); restart(); }); })(s);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(i - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(i + 1); restart(); });

    function setWidths() {
      var w = root.offsetWidth;
      for (var s = 0; s < slides.length; s++) {
        slides[s].style.width = w + 'px';
        slides[s].style.minWidth = w + 'px';
        slides[s].style.flexShrink = '0';
      }
      track.style.transform = 'translateX(-' + (i * w) + 'px)';
    }
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * root.offsetWidth) + 'px)';
      dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
    }
    function restart() { if (!auto || slides.length < 2) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, interval); }
    setWidths();
    window.addEventListener('resize', setWidths);
    go(0); restart();
  });

  /* ---- Size chart modal ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sizechart-open]')) { var o = document.querySelector('[data-sizechart-overlay]'); if (o) o.classList.add('open'); }
    if (e.target.closest('[data-sizechart-close]') || e.target.hasAttribute('data-sizechart-overlay')) {
      var ov = document.querySelector('[data-sizechart-overlay]'); if (ov) ov.classList.remove('open');
    }
  });

  /* ---- Recently viewed (from localStorage) ---- */
  (function () {
    var sec = document.querySelector('[data-recently-viewed]');
    if (!sec) return;
    var grid = sec.querySelector('[data-rv-grid]');
    var list = readStoredArray('otakuen_recently_viewed');
    // exclude the product currently being viewed
    var current = (document.querySelector('[data-pdp] [name="id"]') || {}).value;
    var path = location.pathname;
    list = list.filter(function (x) { return path.indexOf('/products/' + x.h) === -1; });
    if (!list.length) { sec.hidden = true; return; }
    grid.innerHTML = list.slice(0, 4).map(function (x) {
      var itemUrl = safeUrl(x.u, '#');
      var imageUrl = safeUrl(x.i, '');
      var img = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy">' : '🎴';
      return '<article class="card"><a href="' + escapeHtml(itemUrl) + '" class="card__pic">' + img + '</a>' +
        '<div class="card__b"><a href="' + escapeHtml(itemUrl) + '" class="card__nm">' + escapeHtml(x.t) + '</a>' +
        '<div class="card__row"><div class="card__pr">' + escapeHtml(x.p) + '</div></div></div></article>';
    }).join('');
    sec.hidden = false;
  })();

  /* ---- Recently viewed inside cart drawer (empty state) ---- */
  (function () {
    var wrap = document.querySelector('[data-drawer-rv]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-drawer-rv-track]');
    var list = readStoredArray('otakuen_recently_viewed');
    if (!list.length) return;
    track.innerHTML = list.slice(0, 4).map(function (x) {
      var itemUrl = safeUrl(x.u, '#');
      var imageUrl = safeUrl(x.i, '');
      var img = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy">' : '<span class="drawer__rv-ph">🎴</span>';
      return '<a href="' + escapeHtml(itemUrl) + '" class="drawer__rv-card">' + img +
        '<span class="drawer__rv-nm">' + escapeHtml(x.t) + '</span>' +
        '<span class="drawer__rv-pr">' + escapeHtml(x.p) + '</span></a>';
    }).join('');
    wrap.hidden = false;
  })();

  /* ---- Product recommendations (Shopify AI) ---- */
  document.querySelectorAll('[data-product-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var fresh = doc.querySelector('[data-product-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---- Volume / bundle discount tiers ---- */
  (function () {
    var vol = document.querySelector('[data-vol-discount]');
    if (!vol) return;
    var unit = parseInt(vol.getAttribute('data-unit-price'), 10) || 0;
    var tiers = [].slice.call(vol.querySelectorAll('[data-vol-tier]'));
    var qtyInput = document.querySelector('[data-pdp] [data-qty-input]');
    tiers.forEach(function (t) {
      var off = parseFloat(t.getAttribute('data-off')) || 0;
      var each = Math.round(unit * (1 - off / 100));
      var e = t.querySelector('[data-vol-each]');
      if (e) e.textContent = money(each) + '/ea';
      t.addEventListener('click', function () { if (qtyInput) { qtyInput.value = t.getAttribute('data-min'); highlight(); } });
    });
    function highlight() {
      var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var best = null;
      tiers.forEach(function (t) { if (q >= parseInt(t.getAttribute('data-min'), 10)) best = t; });
      tiers.forEach(function (t) { t.classList.toggle('is-active', t === best); });
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', highlight);
      document.querySelectorAll('[data-pdp] [data-qty]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(highlight, 0); }); });
    }
    highlight();
  })();

  /* ---- Cart drawer ---- */
  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  function openDrawer() { if (drawer) { drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]') || e.target.hasAttribute('data-drawer-overlay')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---- Product page (PDP) ---- */
  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var mainImg = pdp.querySelector('[data-pdp-main-img]') || pdp.querySelector('[data-pdp-main] img');

    /* Tabs */
    pdp.querySelectorAll('[data-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-tab');
        pdp.querySelectorAll('[data-tab]').forEach(function (x) { x.classList.toggle('on', x === t); });
        pdp.querySelectorAll('[data-tabpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-tabpanel') !== id; });
      });
    });

    /* Grey out option values that have no available variant given current selection */
    function updateSwatchAvailability() {
      if (!window.__pdpVariants) return;
      var groups = new Set(Array.from(pdp.querySelectorAll('[data-swatch]')).map(function (x) { return x.dataset.group; }));
      var chosen = {};
      pdp.querySelectorAll('[data-swatch].on').forEach(function (x) { chosen[parseInt(x.dataset.group, 10) - 1] = x.dataset.value; });
      pdp.querySelectorAll('[data-swatch]').forEach(function (x) {
        var gi = parseInt(x.dataset.group, 10) - 1;
        var sel = {};
        Object.keys(chosen).forEach(function (k) { sel[k] = chosen[k]; });
        sel[gi] = x.dataset.value;
        var ok = window.__pdpVariants.some(function (v) {
          return Object.keys(sel).every(function (i) { return v.options[i] === sel[i]; }) && v.available;
        });
        x.classList.toggle('is-unavailable', !ok);
        x.disabled = !ok && groups.size === 1;
        x.setAttribute('aria-disabled', String(!ok));
      });
    }
    updateSwatchAvailability();

    /* Swatches — color circles for Color option, text chips for others */
    pdp.querySelectorAll('[data-swatch]').forEach(function (s) {
      s.addEventListener('click', function () {
        var group = s.getAttribute('data-group');
        pdp.querySelectorAll('[data-swatch][data-group="' + group + '"]').forEach(function (x) { x.classList.toggle('on', x === s); });
        /* try to update selected variant */
        var variantInput = pdp.querySelector('[name="id"]');
        if (!variantInput || !window.__pdpVariants) return;
        var opts = [];
        [1,2,3].forEach(function(pos){
          var active = pdp.querySelector('[data-swatch][data-group="'+pos+'"].on');
          if (active) opts[pos-1] = active.getAttribute('data-value');
        });
        var match = window.__pdpVariants.find(function(v){
          return opts.every(function(o,i){ return !o || v.options[i] === o; });
        });
        if (match) {
          variantInput.value = match.id;
          /* update price + compare-at + save */
          var priceEl = pdp.querySelector('[data-pdp-price]');
          if (priceEl && match.price != null) {
            var ph = money(match.price);
            if (match.compare_at_price && match.compare_at_price > match.price) ph += '<s>' + money(match.compare_at_price) + '</s>';
            priceEl.innerHTML = ph;
          }
          var saveEl = pdp.querySelector('[data-pdp-save]');
          if (saveEl) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              var spct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
              saveEl.textContent = 'Save ' + spct + '% today';
              saveEl.hidden = false;
            } else { saveEl.hidden = true; }
          }
          /* update image if variant has one — click matching thumb so zoom lightbox stays in sync */
          if (match.featured_image) {
            var viSrc = match.featured_image.src;
            var viClean = viSrc.split('?')[0];
            var viName = viClean.split('/').pop().replace(/\.[^.]+$/, '').replace(/_\d+x\d*$/, '').replace(/_\d+x$/, '');
            var thumbMatched = null;
            pdp.querySelectorAll('[data-pdp-thumb][data-type="image"]').forEach(function(t){
              if (!t.dataset.src) return;
              var tName = t.dataset.src.split('?')[0].split('/').pop().replace(/\.[^.]+$/, '').replace(/_\d+x\d*$/, '').replace(/_\d+x$/, '');
              if (tName === viName) thumbMatched = t;
            });
            if (thumbMatched) { thumbMatched.click(); }
            else if (mainImg) { mainImg.src = viSrc; mainImg.setAttribute('data-hires', viSrc); }
          }
          /* update ATC button */
          var atcBtn = pdp.querySelector('[data-product-form] button[type="submit"]');
          if (atcBtn) {
            atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
            atcBtn.disabled = !match.available;
          }
          /* toggle back-in-stock form */
          var bisForm = pdp.querySelector('[data-bis-form]');
          if (bisForm) {
            bisForm.hidden = match.available;
            bisForm.setAttribute('data-variant-id', match.id);
            var ok = bisForm.querySelector('.bis-ok');
            var row = bisForm.querySelector('.bis__row');
            if (ok) ok.remove();
            if (row) row.hidden = false;
          }
          /* update sticky bar */
          var stickyPrice = document.querySelector('[data-sticky-price]');
          if (stickyPrice && match.price != null) stickyPrice.textContent = money(match.price);
          var stickyBtn = document.querySelector('[data-sticky-atc]');
          if (stickyBtn) { stickyBtn.setAttribute('data-variant-id', match.id); stickyBtn.disabled = !match.available; stickyBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
          var skuEl = pdp.querySelector('[data-pdp-sku]');
          if (skuEl) skuEl.textContent = match.sku || '';
          var urgency = pdp.querySelector('[data-pdp-urgency]');
          if (urgency) {
            var threshold = parseInt(urgency.dataset.threshold, 10) || 0;
            var tracked = !!match.inventory_management;
            var quantity = Number(match.inventory_quantity) || 0;
            var low = tracked && quantity > 0 && quantity <= threshold;
            var hot = urgency.dataset.hot === 'true';
            urgency.hidden = !low && !hot;
            urgency.classList.toggle('pdp__urgency--hot', !low && hot);
            var urgencyText = urgency.querySelector('[data-pdp-urgency-text]');
            if (urgencyText) urgencyText.textContent = low ? 'Only ' + quantity + ' left!' : urgency.dataset.hotText;
            var stockBar = urgency.querySelector('[data-pdp-stock-bar]');
            if (stockBar) {
              stockBar.hidden = !low;
              var fill = stockBar.querySelector('i');
              if (fill) fill.style.width = Math.min(100, quantity * 100 / threshold) + '%';
            }
          }
          var currentFbt = document.querySelector('[data-fbt-current]');
          if (currentFbt) {
            currentFbt.dataset.id = match.id;
            currentFbt.dataset.price = match.price;
            var currentFbtPrice = document.querySelector('[data-fbt-current-price]');
            if (currentFbtPrice) currentFbtPrice.textContent = money(match.price);
            currentFbt.dispatchEvent(new CustomEvent('fbt:variant-change', { bubbles: true }));
          }
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
        updateSwatchAvailability();
      });
    });

    /* Qty */
    var qtyInput = pdp.querySelector('[data-qty-input]');
    pdp.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        v += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
        qtyInput.value = Math.max(1, v);
      });
    });
  });

  /* ---- Sticky ATC bar (show when main ATC scrolls out of view) ---- */
  (function () {
    var stickyBar = document.querySelector('[data-sticky-atc-bar]');
    if (!stickyBar) return;
    var mainForm = document.querySelector('[data-product-form]');
    if (!mainForm) return;
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(mainForm);

    /* Sticky add-to-cart button click */
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var varId = stickyBtn.getAttribute('data-variant-id') || (document.querySelector('[data-product-form] [name="id"]') || {}).value;
        var qtyInput = document.querySelector('[data-qty-input]');
        var qty = qtyInput ? (parseInt(qtyInput.value,10)||1) : 1;
        if (!varId) return;
        var orig = stickyBtn.textContent;
        stickyBtn.textContent = 'Adding…';
        stickyBtn.disabled = true;
        fetch(route('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: varId, quantity: qty })
        }).then(jsonOrError)
          .then(function(){ return fetch(route('cart.js')); })
          .then(jsonOrError)
          .then(function(cart){
            document.querySelectorAll('.cart-count,[data-drawer-count]').forEach(function(el){ el.textContent = el.hasAttribute('data-drawer-count') ? '('+cart.item_count+')' : cart.item_count; });
            document.querySelectorAll('.bag b').forEach(function(b){ b.textContent = cart.item_count; });
            document.querySelectorAll('.tabbar__badge').forEach(function(el){ el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
            if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            stickyBtn.textContent = '✓ Added!';
            openDrawer();
            setTimeout(function(){ stickyBtn.textContent = orig; stickyBtn.disabled = false; }, 1500);
          })
          .catch(function(){ stickyBtn.textContent = orig; stickyBtn.disabled = false; });
      });
    }
  })();

  /* ---- Back-in-stock notification form ---- */
  (function(){
    document.addEventListener('submit', function(e){
      var form = e.target.closest('[data-bis-form]');
      if (!form) return;
      e.preventDefault();
      var email = form.querySelector('[data-bis-email]').value;
      var varId = form.getAttribute('data-variant-id');
      var btn = form.querySelector('button[type="submit"]');
      var orig = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Saving…';
      /* Store in Shopify customer notes via contact form as fallback */
      fetch(route('contact'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=contact&utf8=✓&contact[email]=' + encodeURIComponent(email) + '&contact[body]=Back+in+stock+request+for+variant+' + encodeURIComponent(varId) + '+on+page+' + encodeURIComponent(location.href)
      }).then(function(response){
        if (!response.ok) throw new Error('Request failed');
        form.innerHTML = '<p class="bis-ok">Request received. We\'ll contact you when stock information is available.</p>';
      }).catch(function(){
        if (btn) btn.textContent = orig;
      });
    });
  })();

  /* ---- AJAX add to cart (cart count update + open drawer) ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      var qtyField = form.querySelector('[data-qty-input]');
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch(route('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: qtyField ? (parseInt(qtyField.value, 10) || 1) : 1
        })
      })
        .then(jsonOrError)
        .then(function () { return fetch(route('cart.js')); })
        .then(jsonOrError)
        .then(function (cart) {
          document.querySelectorAll('.cart-count, [data-drawer-count]').forEach(function (el) {
            el.textContent = el.hasAttribute('data-drawer-count') ? '(' + cart.item_count + ')' : cart.item_count;
          });
          document.querySelectorAll('.bag b').forEach(function (b) { b.textContent = cart.item_count; });
          document.querySelectorAll('.tabbar__badge').forEach(function(el){ el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (btn) btn.textContent = '✓ Added!';
          openDrawer();
          setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1500);
        })
        .catch(function () {
          if (!btn) return;
          btn.textContent = 'Could not add';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
        });
    });
  });

  /* ---- Wishlist (localStorage) ---- */
  (function () {
    var KEY = 'otakuen_wishlist';
    function load() { return readStoredArray(KEY); }
    function save(list) { localStorage.setItem(KEY, JSON.stringify(list)); }
    function has(handle) { return load().some(function(x){ return x.handle === handle; }); }

    function syncButtons() {
      document.querySelectorAll('[data-wish]').forEach(function(btn) {
        var h = btn.getAttribute('data-wish');
        btn.classList.toggle('on', has(h));
        btn.textContent = has(h) ? '♥' : '♡';
      });
      var badge = document.querySelector('[data-wish-count]');
      if (badge) { var n = load().length; badge.textContent = n || ''; }
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wish]');
      if (!btn || btn.closest('.wl-grid')) return; // wl-grid has own handler
      e.preventDefault(); e.stopPropagation();
      var handle = btn.getAttribute('data-wish');
      var list = load();
      if (has(handle)) {
        list = list.filter(function(x){ return x.handle !== handle; });
      } else {
        list.push({
          handle: handle,
          title: btn.getAttribute('data-wish-title') || handle,
          url: btn.getAttribute('data-wish-url') || route('products/' + handle),
          img: btn.getAttribute('data-wish-img') || '',
          price: btn.getAttribute('data-wish-price') || ''
        });
      }
      save(list);
      syncButtons();
      window.dispatchEvent(new CustomEvent('wishlist-updated'));
    });

    syncButtons();
    window.addEventListener('wishlist-updated', syncButtons);
  })();

  /* ---- Back-to-top ---- */
  (function () {
    var btn = document.getElementById('backToTop');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      var show = window.scrollY > 400;
      btn.hidden = !show;
      btn.classList.toggle('visible', show);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  /* ---- AJAX loading bar ---- */
  (function () {
    var bar = document.getElementById('ajaxBar');
    if (!bar) return;
    var timer;
    function start() {
      bar.style.width = '0%';
      bar.classList.add('active');
      bar.style.transition = 'none';
      requestAnimationFrame(function () {
        bar.style.transition = 'width 12s cubic-bezier(.1,.9,.3,1)';
        bar.style.width = '85%';
      });
    }
    function finish() {
      bar.style.transition = 'width .2s ease';
      bar.style.width = '100%';
      clearTimeout(timer);
      timer = setTimeout(function () {
        bar.classList.remove('active');
        bar.style.width = '0%';
      }, 300);
    }
    var origFetch = window.fetch;
    window.fetch = function () {
      start();
      return origFetch.apply(this, arguments).then(function (r) { finish(); return r; }, function (e) { finish(); throw e; });
    };
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript') || link.target === '_blank') return;
      start();
    });
  })();

  /* ---- Hide-on-scroll header — disabled in theme editor ---- */
  (function () {
    if (window.Shopify && window.Shopify.designMode) return;
    var header = document.querySelector('.hdr, .site-header, header[role="banner"], .header');
    if (!header) return;
    var lastY = 0;
    var ticking = false;
    var THRESHOLD = 80;
    function update() {
      var y = window.scrollY;
      if (y > THRESHOLD) {
        header.classList.toggle('header--hidden', y > lastY);
      } else {
        header.classList.remove('header--hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  })();

  /* ---- Focus trap utility (no auto-focus to avoid editor interference) ---- */
  window.trapFocus = function (el) {
    var focusable = el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) { if (document.activeElement === first) { e.preventDefault(); last && last.focus(); } }
      else { if (document.activeElement === last) { e.preventDefault(); first && first.focus(); } }
    }
    el.addEventListener('keydown', handler);
    return function () { el.removeEventListener('keydown', handler); };
  };

  /* Wire focus trap to overlays */
  (function () {
    if (window.Shopify && window.Shopify.designMode) return;
    var releaseFns = {};
    function watchOverlay(selector, id) {
      var target = document.querySelector(selector);
      if (!target) return;
      new MutationObserver(function () {
        if (target.classList.contains('open')) {
          if (!releaseFns[id]) releaseFns[id] = window.trapFocus(target);
        } else {
          if (releaseFns[id]) { releaseFns[id](); releaseFns[id] = null; }
        }
      }).observe(target, { attributes: true, attributeFilter: ['class'] });
    }
    watchOverlay('[data-drawer]', 'cart');
    watchOverlay('[data-search-ov]', 'search');
    watchOverlay('#mobNav', 'mobnav');
  })();

})();

/* ============================================================
   BATCH J — Card swatches + Quick Add AJAX
   ============================================================ */
(function () {

  /* --- Swatch click: swap image, price, variant on card --- */
  function initSwatches(card) {
    var swatches = card.querySelectorAll('[data-card-swatches] .card__swatch');
    var primaryImg = card.querySelector('.card__img--primary');
    var hoverImg   = card.querySelector('.card__img--hover');
    var priceEl    = card.querySelector('[data-card-price]');
    var quickBtn   = card.querySelector('[data-quick-add]');

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('on'); });
        sw.classList.add('on');

        var img     = sw.dataset.swatchImg;
        var price   = sw.dataset.swatchPrice;
        var compare = sw.dataset.swatchCompare;
        var vid     = sw.dataset.swatchVariant;
        var available = sw.dataset.swatchAvailable === 'true';
        var onSale = sw.dataset.swatchOnSale === 'true';

        if (img && primaryImg) { primaryImg.src = img; }
        if (img && hoverImg)   { hoverImg.src   = img; }

        if (priceEl && price) {
          priceEl.textContent = '';
          var priceMain = document.createElement('span');
          priceMain.className = 'card__price-main';
          var currentPrice = document.createElement('span');
          currentPrice.className = 'card__price-current' + (onSale ? ' is-sale' : '');
          currentPrice.textContent = price;
          priceMain.appendChild(currentPrice);
          priceEl.appendChild(priceMain);
          if (onSale && compare) {
            var compareEl = document.createElement('s');
            compareEl.className = 'card__price-compare';
            compareEl.textContent = compare;
            priceEl.appendChild(compareEl);
          }
        }

        if (quickBtn && vid) {
          quickBtn.dataset.variantId = vid;
          quickBtn.disabled = !available;
          quickBtn.textContent = available ? '＋' : '✕';
        }
      });
    });
  }

  /* --- Quick Add AJAX --- */
  function initQuickAdd(card) {
    var btn = card.querySelector('[data-quick-add]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var vid = btn.dataset.variantId;
      if (!vid || btn.disabled || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      btn.textContent = '';

      fetch(route('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        btn.textContent = '✓';

        /* Refresh cart count in header */
        fetch(route('cart.js'))
          .then(jsonOrError)
          .then(function (c) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = c.item_count;
              el.hidden = c.item_count === 0;
            });
            document.querySelectorAll('.bag b, [data-drawer-count]').forEach(function (el) {
              el.textContent = el.hasAttribute('data-drawer-count') ? '(' + c.item_count + ')' : c.item_count;
            });
            if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer(c);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
          });

        /* Open cart drawer if present */
        var drawer = document.querySelector('[data-drawer]');
        if (drawer) {
          drawer.classList.add('open');
          drawer.setAttribute('aria-hidden', 'false');
          var ovEl = document.querySelector('[data-drawer-overlay]');
          if (ovEl) ovEl.classList.add('open');
          document.body.classList.add('drawer-open');
        }

        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.textContent = '＋';
        }, 2200);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.textContent = '＋';
        console.warn('[QuickAdd]', err);
      });
    });
  }

  /* --- Init on all current + future cards --- */
  function initCard(card) {
    initSwatches(card);
    initQuickAdd(card);
  }

  document.querySelectorAll('[data-card-product]').forEach(initCard);

  /* Watch for AJAX-appended cards (Load More, search) */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-card-product]')) { initCard(node); }
        node.querySelectorAll && node.querySelectorAll('[data-card-product]').forEach(initCard);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();

/* ============================================================
   BATCH L — Image zoom lightbox, video overlay, swipe gallery
   ============================================================ */
(function () {

  /* ---- Collect PDP image sources ---- */
  function getPdpImages() {
    var thumbs = document.querySelectorAll('[data-pdp-thumb][data-type="image"]');
    return Array.from(thumbs).map(function (t) { return t.dataset.zoom || t.dataset.src; }).filter(Boolean);
  }

  /* ---- Zoom lightbox ---- */
  var zoomEl    = document.getElementById('pdpZoom');
  var zoomImg   = zoomEl && zoomEl.querySelector('[data-zoom-active-img]');
  var zoomDots  = zoomEl && zoomEl.querySelector('[data-zoom-dots]');
  var zoomIdx   = 0;
  var zoomSrcs  = [];

  function buildDots(sources) {
    if (!zoomDots) return;
    zoomDots.innerHTML = '';
    sources.forEach(function (_, i) {
      var d = document.createElement('button');
      d.className = 'pdp-zoom__dot' + (i === 0 ? ' on' : '');
      d.setAttribute('aria-label', 'Image ' + (i + 1));
      d.addEventListener('click', function () { showZoom(i); });
      zoomDots.appendChild(d);
    });
  }

  function showZoom(idx) {
    if (!zoomEl || !zoomImg) return;
    zoomIdx = (idx + zoomSrcs.length) % zoomSrcs.length;
    zoomImg.src = zoomSrcs[zoomIdx];
    zoomImg.classList.remove('zoomed');
    zoomEl.querySelectorAll('.pdp-zoom__dot').forEach(function (d, i) {
      d.classList.toggle('on', i === zoomIdx);
    });
  }

  function openZoom(startIdx) {
    if (!zoomEl) return;
    zoomSrcs = getPdpImages();
    if (!zoomSrcs.length) return;
    buildDots(zoomSrcs);
    showZoom(startIdx || 0);
    zoomEl.hidden = false;
    document.body.style.overflow = 'hidden';
    zoomEl.focus && zoomEl.focus();
  }

  function closeZoom() {
    if (!zoomEl) return;
    zoomEl.hidden = true;
    document.body.style.overflow = '';
  }

  if (zoomEl) {
    zoomEl.querySelector('[data-zoom-close]').addEventListener('click', closeZoom);
    zoomEl.querySelector('[data-zoom-prev]').addEventListener('click', function () { showZoom(zoomIdx - 1); });
    zoomEl.querySelector('[data-zoom-next]').addEventListener('click', function () { showZoom(zoomIdx + 1); });
    zoomEl.addEventListener('click', function (e) {
      if (e.target === zoomEl || e.target.classList.contains('pdp-zoom__stage')) closeZoom();
    });
    /* Toggle pixel-zoom on image click */
    if (zoomImg) {
      zoomImg.addEventListener('click', function () {
        zoomImg.classList.toggle('zoomed');
      });
    }
    /* Keyboard nav */
    document.addEventListener('keydown', function (e) {
      if (zoomEl.hidden) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft')  showZoom(zoomIdx - 1);
      if (e.key === 'ArrowRight') showZoom(zoomIdx + 1);
    });
  }

  /* Open zoom from main image or zoom button */
  document.querySelectorAll('[data-zoom-open],[data-zoom-img]').forEach(function (el) {
    el.addEventListener('click', function () {
      var thumbs = document.querySelectorAll('[data-pdp-thumb][data-type="image"]');
      var cur = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('on')) cur = i; });
      openZoom(cur);
    });
  });

  /* ---- Video overlay ---- */
  var videoOv    = document.getElementById('pdpVideoOv');
  var videoFrame = document.getElementById('pdpVideoFrame');

  function toEmbedUrl(url) {
    if (!url) return '';
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1';
    var vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return url;
  }

  function openVideo(url) {
    if (!videoOv || !videoFrame) return;
    videoFrame.src = toEmbedUrl(url);
    videoOv.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeVideo() {
    if (!videoOv || !videoFrame) return;
    videoFrame.src = '';
    videoOv.hidden = true;
    document.body.style.overflow = '';
  }

  if (videoOv) {
    videoOv.querySelector('[data-video-close]').addEventListener('click', closeVideo);
    videoOv.addEventListener('click', function (e) {
      if (e.target === videoOv) closeVideo();
    });
  }

  /* Thumb click router — image vs video */
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb, idx) {
    thumb.addEventListener('click', function () {
      if (thumb.dataset.type === 'video') {
        openVideo(thumb.dataset.video);
        return;
      }
      /* image thumb — existing behavior + update zoom src */
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('on'); });
      thumb.classList.add('on');
      /* target the desktop single image specifically (swipe slides also carry [data-zoom-img]) */
      var main = document.querySelector('[data-pdp-main-img]') || document.querySelector('[data-pdp-main] [data-zoom-img]');
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
        main.dataset.zoomSrc = thumb.dataset.zoom || thumb.dataset.src;
      }
    });
  });

  /* ---- Touch swipe on PDP main image ----
     Skipped when the native scroll-snap swipe track is present (it
     handles mobile swiping itself); only used as a fallback. */
  (function () {
    var mainEl = document.querySelector('[data-pdp-main]');
    if (!mainEl) return;
    if (document.querySelector('[data-pdp-swipe]')) return;
    var startX = 0, startY = 0;
    mainEl.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 30 || Math.abs(dy) > Math.abs(dx)) return;
      var thumbs = Array.from(document.querySelectorAll('[data-pdp-thumb]'));
      var cur = thumbs.findIndex(function (t) { return t.classList.contains('on'); });
      var next = dx < 0 ? Math.min(cur + 1, thumbs.length - 1) : Math.max(cur - 1, 0);
      if (next !== cur) thumbs[next] && thumbs[next].click();
    }, { passive: true });
  })();

  /* ---- Mobile bottom nav — sync cart count ---- */
  (function () {
    function syncCount() {
      fetch(route('cart.js'))
        .then(jsonOrError)
        .then(function (c) {
          document.querySelectorAll('.tabbar__badge').forEach(function (el) {
            el.textContent = c.item_count;
            el.hidden = c.item_count === 0;
          });
        });
    }
    syncCount();
    document.addEventListener('cart:updated', syncCount);
  })();

})();

/* ============================================================
   BATCH M — Animated stats counter (count-up on scroll)
   ============================================================ */
(function () {
  var groups = document.querySelectorAll('[data-stats]');
  if (!groups.length) return;

  function animate(el) {
    var target   = parseFloat(el.getAttribute('data-stat-target')) || 0;
    var decimals = parseInt(el.getAttribute('data-stat-decimals'), 10) || 0;
    var dur = 1600, start = null;
    function fmt(n) {
      return n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(tick);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('[data-stat-target]').forEach(animate);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  groups.forEach(function (g) { io.observe(g); });
})();

/* ============================================================
   BATCH O — Product compare (localStorage, max 4)
   ============================================================ */
(function () {
  var bar = document.querySelector('[data-compare-bar]');
  if (!bar) return; /* compare disabled */

  var KEY = 'otakuen_compare';
  var MAX = 4;
  var itemsWrap = bar.querySelector('[data-compare-items]');
  var countEl   = bar.querySelector('[data-compare-count]');
  var modal     = document.querySelector('[data-compare-modal]');
  var tableWrap = modal && modal.querySelector('[data-compare-table]');

  function read() {
    if (window.Otakuen && Otakuen.readStoredArray) return Otakuen.readStoredArray(KEY);
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) { return []; }
  }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function esc(value) { return window.Otakuen ? Otakuen.escapeHtml(value) : String(value || ''); }
  function url(value) { return window.Otakuen ? Otakuen.safeUrl(value, '#') : '#'; }

  function syncButtons(list) {
    var handles = list.map(function (x) { return x.h; });
    document.querySelectorAll('[data-compare]').forEach(function (btn) {
      btn.classList.toggle('on', handles.indexOf(btn.getAttribute('data-compare')) !== -1);
    });
  }

  function renderBar() {
    var list = read();
    countEl.textContent = list.length;
    if (!list.length) { bar.hidden = true; return; }
    bar.hidden = false;
    itemsWrap.innerHTML = list.map(function (x) {
      var imageUrl = url(x.i);
      var img = x.i && imageUrl !== '#' ? '<img src="' + esc(imageUrl) + '" alt="">' : '<span class="cmp-bar__ph">🎴</span>';
      return '<div class="cmp-bar__item">' + img +
        '<button class="cmp-bar__remove" data-compare-remove="' + esc(x.h) + '" aria-label="Remove">×</button></div>';
    }).join('');
    syncButtons(list);
  }

  function add(data) {
    var list = read();
    if (list.some(function (x) { return x.h === data.h; })) return;
    if (list.length >= MAX) {
      if (window.toast) window.toast('You can compare up to ' + MAX + ' products.');
      else alert('You can compare up to ' + MAX + ' products.');
      return;
    }
    list.push(data); write(list); renderBar();
  }
  function remove(handle) {
    write(read().filter(function (x) { return x.h !== handle; }));
    renderBar();
  }

  /* Toggle from card buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-compare]');
    if (btn) {
      e.preventDefault();
      var handle = btn.getAttribute('data-compare');
      if (read().some(function (x) { return x.h === handle; })) { remove(handle); }
      else {
        add({
          h: handle,
          t: btn.getAttribute('data-compare-title'),
          u: btn.getAttribute('data-compare-url'),
          i: btn.getAttribute('data-compare-img'),
          p: btn.getAttribute('data-compare-price'),
          ty: btn.getAttribute('data-compare-type'),
          v: btn.getAttribute('data-compare-vendor'),
          a: btn.getAttribute('data-compare-available')
        });
      }
      return;
    }
    var rm = e.target.closest('[data-compare-remove]');
    if (rm) { remove(rm.getAttribute('data-compare-remove')); return; }
    if (e.target.closest('[data-compare-clear]')) { write([]); renderBar(); return; }
    if (e.target.closest('[data-compare-open]')) { openModal(); return; }
    if (e.target.closest('[data-compare-close]')) { closeModal(); return; }
  });

  function row(label, cells) {
    return '<tr><th>' + esc(label) + '</th>' + cells.map(function (c) { return '<td>' + (c || '—') + '</td>'; }).join('') + '</tr>';
  }

  function openModal() {
    var list = read();
    if (!list.length || !modal) return;
    tableWrap.innerHTML =
      '<table class="cmp-table"><tbody>' +
      '<tr class="cmp-table__imgs"><th></th>' + list.map(function (x) {
        var itemUrl = url(x.u);
        var imageUrl = url(x.i);
        return '<td><a href="' + esc(itemUrl) + '">' + (x.i && imageUrl !== '#' ? '<img src="' + esc(imageUrl) + '" alt="">' : '🎴') + '</a></td>';
      }).join('') + '</tr>' +
      row('Product', list.map(function (x) { return '<a href="' + esc(url(x.u)) + '" class="cmp-table__name">' + esc(x.t) + '</a>'; })) +
      row('Price', list.map(function (x) { return '<strong>' + esc(x.p) + '</strong>'; })) +
      row('Type', list.map(function (x) { return esc(x.ty); })) +
      row('Brand', list.map(function (x) { return esc(x.v); })) +
      row('Availability', list.map(function (x) { return x.a === 'true' ? '✅ In stock' : '✕ Sold out'; })) +
      '<tr class="cmp-table__cta"><th></th>' + list.map(function (x) {
        return '<td><a href="' + esc(url(x.u)) + '" class="btn btn--sm">View →</a></td>';
      }).join('') + '</tr>' +
      '</tbody></table>';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() { if (modal) { modal.hidden = true; document.body.style.overflow = ''; } }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  renderBar();
})();

/* ============================================================
   Advanced section FX — scroll reveal (IntersectionObserver)
   Menambah [data-reveal] + stagger ke item dalam .fx-reveal,
   lalu .is-in saat masuk viewport. CSS yang menyembunyikan
   dijaga oleh @media (prefers-reduced-motion:no-preference).
   ============================================================ */
(function () {
  var sections = document.querySelectorAll('.fx-reveal');
  if (!sections.length || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  var sel = '.sec__head,.stats__head,.mcol__c,.rev,.cap,.stat,.card,.trust__c,.iwt__media,.iwt__body,.logos,.bnr__slide';

  sections.forEach(function (sec) {
    var items = sec.querySelectorAll(sel);
    if (!items.length) items = sec.children;
    var n = 0;
    Array.prototype.forEach.call(items, function (el) {
      if (el.closest('.fx-reveal') !== sec) return;
      el.setAttribute('data-reveal', '');
      el.style.setProperty('--reveal-d', (Math.min(n, 8) * 60) + 'ms');
      io.observe(el);
      n++;
    });
  });
})();
